// extracted by mini-css-extract-plugin
module.exports = {"btn":"F-starred-btn-J-nFK","starredBtn":"F-starred-starred-btn-10Cqv","starred":"F-starred-starred-F8JQ1"};